import { useSelector } from "react-redux";
import classes from "./FullPageLoading.module.css";
import { useEffect } from "react";

const FullPageLoading = () => {
  const { fullPageLoading } = useSelector(
    (state) => state.fullPageLoadingSlice
  );

  useEffect(() => {
    const htmlBody = document.querySelector("body");
    if (fullPageLoading) {
      htmlBody.style.overflow = "hidden";
    } else {
      htmlBody.style.overflowY = "auto";
    }
    return () => (htmlBody.style.overflowY = "auto");
  }, [fullPageLoading]);

  return (
    <div className={classes.rootLoading}>
      <div className={classes.logo}>
        <svg
          version="1.1"
          x="0px"
          y="0px"
          viewBox="0 0 708.66 442.04"
          style={{ enableBackground: "new 0 0 600 600" }}
          className={classes.bayleyssvg}
        >
          <polygon
            className={classes["cls-1"]}
            strokeDasharray="1200 1000"
            points="437.2 293.21 636.45 178.17 636.45 144.7 437.2 259.73 437.2 293.21"
          />
          <polygon
            className={classes["cls-1"]}
            strokeDasharray="1200 1000"
            points="437.2 148.51 636.45 33.48 636.45 0 437.2 115.03 437.2 148.51"
          />
          <path
            id="bayleys"
            className={classes.bayleys}
            strokeDasharray="1200 1000"
            d="m96.73,438.92v-74.48h-58.21v74.48H0v-180.99h38.52v75.76h58.21v-75.76h38.52v180.99h-38.52Zm539.71-64.68c0-10.76,2.34-21.03,6.99-30.74,2.15-4.09,4.96-7.79,8.46-10.83,2.17-1.94,4.56-3.2,7.22-3.75,4.03-.83,8.36-.69,10.16,3.53.48,1.13.78,2.38,1,3.49,1.23,6.14,1.29,17.6,1.29,21.92v81.06h37.1v-95.87c-.15-12.55-2.58-26.25-11.37-35.8-7.11-7.86-15.94-11.45-25.4-11.57-15.25-.2-31.19,9.23-35.46,23.95v-83s-36.89,21.3-36.89,21.3v180.99h36.89v-64.68Zm-482.45,38.8c-3.97-6.62-6.96-14.26-8.95-22.83-1.99-8.57-2.99-18.07-2.99-28.42,0-6.42.45-12.95,1.6-19.33,1.02-5.63,2.59-11.15,4.89-16.38,2.73-6.2,6.54-11.96,11.47-16.62,5.66-5.36,12.73-9.31,21.14-11.6,5.64-1.54,11.89-2.33,18.72-2.31,4.99-.01,10,.49,14.86,1.67,6.08,1.47,11.47,3.9,16.11,7.19,5.56,3.94,10.01,9.15,13.26,15.11,3.94,7.22,6.27,15.74,7.12,25.2.4,4.43.37,8.85.37,13.29v6.42s-37.29,0-37.29,0h-37.29c.49,5.9,1.82,11.88,3.94,17.54,1.86,4.97,4.36,9.84,7.55,14.19,3.18,4.34,7.05,8.15,11.63,10.99,6.18,3.82,13.18,5.56,20.41,5.56,7.72.02,15.63-2.12,22.82-4.79l5.05-1.86v29.55l-2.54.87c-6.88,2.35-13.98,3.91-21.7,4.75-4.77.52-9.7.83-14.62.79-4.92-.03-9.84-.41-14.58-1.26-5.23-.93-10.14-2.4-14.68-4.38-4.55-1.98-8.73-4.49-12.53-7.49-5.54-4.39-10.14-9.81-13.77-15.86Zm61.97-74.8c-.2-1.27-.51-2.6-.94-3.9-1.09-3.27-2.96-6.19-5.78-8.23-1.3-.94-2.86-1.73-4.78-2.29-5.15-1.51-11.34-1.33-16.11,1.22-3.64,1.95-6.4,5.19-8.2,8.85-.72,1.46-1.27,2.94-1.68,4.34h37.5Zm94.2-10.62v59.01c0,2.83.06,5.57.26,8.11.31,4.06.97,8.67,3.15,12.23,1.74,2.85,4.36,4.48,7.54,5.22,3.72.86,7.73.59,11.45-.1,3.7-.69,7.36-1.75,11-2.71v29.78s-3.11.55-3.11.55c-4.19.74-8.46,1.32-12.74,1.71-4.19.38-8.48.63-12.76.59-4.28-.03-8.55-.35-12.71-1.09-5.83-1.03-11.6-2.97-16.42-6.52-3.97-2.92-6.96-6.75-8.97-11.25-1.18-2.65-2-5.45-2.56-8.34-1.15-6.02-1.07-12.1-1.07-18.19v-69.01h-24.65v-28.99h24.65v-40.69l36.89-21.3.03,61.99h46.62v-40.69l36.9-21.3.03,61.99h37.31v28.99h-37.31v59.01c0,2.83.06,5.57.26,8.11.31,4.06.97,8.67,3.15,12.23,1.75,2.85,4.35,4.48,7.54,5.22,3.72.86,7.73.59,11.45-.1,3.7-.69,7.36-1.75,11-2.71v29.78l-3.11.55c-4.2.74-8.46,1.32-12.74,1.71-4.19.38-8.48.63-12.76.59-4.28-.03-8.55-.35-12.71-1.09-5.83-1.03-11.6-2.97-16.42-6.52-3.97-2.92-6.96-6.75-8.97-11.25-1.19-2.65-2-5.45-2.56-8.34-1.15-6.02-1.07-12.1-1.07-18.19v-69.01h-46.61Zm130.8,111.31h-3.76v-140.3h36.93v140.3h-33.17Zm50.98-27.21c-3.87-6.43-6.85-13.92-8.81-22.51-1.54-6.75-2.47-13.95-2.73-21.18-.26-7.24.15-14.51,1.3-21.39,1.06-6.34,2.78-12.39,5.26-17.98,3.42-7.71,8.37-14.71,14.86-20.12,6.71-5.59,15.09-9.62,25.11-11.59,9.52-1.88,20.34-1.94,29.86,0,7.48,1.52,13.69,4.24,18.72,7.89,6.31,4.58,10.91,10.85,13.81,18.07,2.78,6.89,3.99,14.44,4.27,21.98.08,2.25.06,4.5.06,6.75h-38.78v-3.76c0-1.97-.08-3.94-.27-5.85-.39-3.92-1.25-8.17-3.44-11.55-1.82-2.81-4.41-4.53-7.64-5.23-2.86-.62-6.13-.54-8.93.28-2.82.82-5.27,2.42-7.27,4.56-2.41,2.57-4.11,5.79-5.3,9.08-.92,2.54-1.63,5.36-2.1,8.4-1.13,7.19-.92,14.82.25,21.98.65,3.95,1.62,7.88,2.95,11.66,3.3,9.4,8.89,17.96,17.14,23.74,4.51,3.16,9.85,5.51,16.2,6.77,6.08,1.2,12.51,1.3,18.67.66,4.55-.47,8.45-1.39,12.16-2.74l5.05-1.85v27.07l-2.59.85c-7.77,2.53-16.19,4.54-25.1,5.57-4.36.5-8.79.77-13.23.76-4.43-.02-8.85-.32-13.21-.95-7.29-1.07-14.21-3.05-20.56-6.05-10.79-5.1-19.57-13.09-25.7-23.28Z"
          />
          <polygon
            className={classes["cls-1"]}
            strokeDasharray="1200 1000"
            points="437.2 244.97 636.45 129.94 636.45 96.46 437.2 211.5 437.2 244.97"
          />
          <polygon
            className={classes["cls-1"]}
            strokeDasharray="1200 1000"
            points="437.2 196.74 636.45 81.71 636.45 48.23 437.2 163.27 437.2 196.74"
          />
        </svg>
      </div>
    </div>
  );
};

export default FullPageLoading;
